<ng-content select="accordion-item"></ng-content>
<ng-content select="ng-container"></ng-content>